import { CollaborationResult } from '@/infrastructure/gateways/classroom/models/collaboration-result';

const collaborationName = 'RecordVideoWatchingCollaboration';

export const VideoWatchingRecordedIdentifier = 'VideoWatchingRecorded';
export class VideoWatchingRecorded extends CollaborationResult {
  constructor() {
    super(collaborationName, VideoWatchingRecordedIdentifier, 'Video watching recorded');
  }
}

export const VideoWatchingNotRecordedBecauseStudentNotFoundIdentifier =
  'VideoWatchingNotRecordedBecauseStudentNotFound';
export class VideoWatchingNotRecordedBecauseStudentNotFound extends CollaborationResult {
  constructor() {
    super(
      collaborationName,
      VideoWatchingNotRecordedBecauseStudentNotFoundIdentifier,
      'Unable to record video watching, student not found',
    );
  }
}

export const RecordVideoWatchingUnexpectedErrorIdentifier = 'RecordVideoWatchingUnexpectedError';
export class RecordVideoWatchingUnexpectedError extends CollaborationResult {
  constructor() {
    super(
      collaborationName,
      RecordVideoWatchingUnexpectedErrorIdentifier,
      'Unexpected error occurred on recording video watching',
    );
  }
}
